export default __webpack_public_path__ + "static/media/portal.4e3c66be.svg";